import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import LoadingAnimation from '../../components/loading/LoadingAnimation'
const Novedades = lazy(() => import("../home/Novedades"));
const NoticiasRecientes = lazy(() => import("../home/NoticiasRecientes"));
const Menu = lazy(() => import("../menu/Menu"));
const Footer = lazy(() => import("../footer/Footer"));
export default function Index() {
    return (
        <Suspense fallback={<LoadingAnimation />}>
            <Fragment>
                <Helmet>
                    <meta
                        name="description"
                        content="Bienvenido al sitio web oficial de Hyundai Ecuador. Conoce nuestra amplia gama de modelos, concesionarios y todos los servicios especialmente pensados para ti."
                    />
                    <meta
                        name="keywords"
                        content="Hyundai, vehículos, autos, sedán, hatchback, Hyundai es mejor, taller, concesionario, calidad"
                    />
                    <title>Hyundai Ecuador</title>
                </Helmet>
                <Menu />
                <Novedades />
                <NoticiasRecientes />
                <Footer/>
            </Fragment>
        </Suspense>
    );
}